import axios from 'axios';
import { getAuthHeader } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export interface University {
  id: number;
  name: string;
  emailDomain?: string;
  contactEmail?: string;
  phoneNumber?: string;
  address?: string;
  status: string;
  studentCount: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateUniversityRequest {
  name: string;
  emailDomain?: string;
  contactEmail?: string;
  phoneNumber?: string;
  address?: string;
  status: string;
}

class UniversityService {
  async getUniversities(): Promise<University[]> {
    try {
      const response = await axios.get(`${API_BASE_URL}/organizations`, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching universities:', error);
      throw error;
    }
  }

  async getUniversity(id: number): Promise<University> {
    try {
      const response = await axios.get(`${API_BASE_URL}/organizations/${id}`, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching university:', error);
      throw error;
    }
  }

  async createUniversity(data: CreateUniversityRequest): Promise<University> {
    try {
      const response = await axios.post(`${API_BASE_URL}/organizations`, data, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Error creating university:', error);
      throw error;
    }
  }

  async updateUniversity(id: number, data: Partial<CreateUniversityRequest>): Promise<University> {
    try {
      const response = await axios.put(`${API_BASE_URL}/organizations/${id}`, data, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating university:', error);
      throw error;
    }
  }

  async deleteUniversity(id: number): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/organizations/${id}`, {
        headers: getAuthHeader()
      });
    } catch (error) {
      console.error('Error deleting university:', error);
      throw error;
    }
  }
}

const universityService = new UniversityService();
export default universityService;